var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"ds-text-xs md:ds-text-sm font-medium text-gray-900 my-auto",class:{'text-nowrap': _vm.wrapText},domProps:{"innerHTML":_vm._s(_vm.value ? _vm.value : '–')}}),_c('p',{staticClass:"ds-text-2xs md:ds-text-2xs font-bold text-gray-500 uppercase text-nowrap"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }